export default __webpack_public_path__ + "static/media/113.d73dac30.png";